import React from 'react';
import './HolidayOffers.css';

const holidayData = [
  {
    image: 'https://www.trip.net.in/wp-content/uploads/Goa-Tour-Packages-trip.net_.in_.jpg',
    title: 'Goa Offer 40%',
    subtitle: 'Mon to Wed',
    originalPrice: 9999,
    offerPrice: 4999,
    discount: '10%',
  },
  {
    image: 'https://www.enlivetrips.com/uploads/posts/Kashmir%20Valley%20Tour%20Package.jpg',
    title: 'Kashmir a Heaven On Earth On Night',
    subtitle: 'Limited period offer',
    originalPrice: 9999,
    offerPrice: 7300,
    discount: '27%',
  },
  {
    image: 'https://s7ap1.scene7.com/is/image/incredibleindia/The-Best-Adventure-Experiences-in-Manali1-popular?qlt=82&ts=1726730921047',
    title: 'Manali Mountain Escape',
    subtitle: 'Book now for summer',
    originalPrice: 8500,
    offerPrice: 6400,
    discount: '25%',
  }
];

const HolidayOffers = () => {
  return (
    <div className="offers-container">
      <h2 className="offers-heading">
        HOLIDAY PACKAGES <span className="highlight">OFFERS INDIA</span>
      </h2>
      <p className="offers-subtext">
        BOOK A INDIA HOLIDAY WITH SPECIAL OFFERS AND DEALS AND GET ATTRACTIVE DISCOUNTS AND CASHBACK.
      </p>

      <div className="offers-card-wrapper">
        {holidayData.map((item, index) => (
          <div key={index} className="offer-card">
            <div className="image-wrapper">
              <img src={item.image} alt={item.title} />
              <span className="discount-badge">{item.discount} OFF</span>
            </div>
            <div className="card-content">
              <h4>{item.title}</h4>
              <small>{item.subtitle}</small>
              <div className="price-row">
                <span className="starting-from">Starting From:</span>
                <span className="original-price">INR {item.originalPrice.toLocaleString()}</span>
                <span className="offer-price">INR {item.offerPrice.toLocaleString()}</span>
              </div>
              <button className="view-button">View Details</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HolidayOffers;
